module.exports = __webpack_public_path__ + "static/img/1578_phase_function_Paper_PointsHejduk_Prediction.c1374f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1578_phase_function_Paper_PointsHejduk_Prediction.png
// module id = PaVO
// module chunks = 0